// inner utility function to convert rem value to pixels
const remToPixels = (rem: number) => {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
};

// Find all labels of inputs inside given element.
// this makes sure the labels position is correct, and that the label's container has a top margin big enough to contain it
export const fixInputSpacing = (formContainer: HTMLElement) => {
    const inputs = Array.from<HTMLElement>(
        formContainer.querySelectorAll("mat-form-field > div.mat-form-field-wrapper")
    );
    const inputLabelHeights = inputs
        .map((inputRef) => inputRef.querySelector("span.mat-form-field-label-wrapper"))
        .map((labelRef) => labelRef.getBoundingClientRect().height);

    // size of the spacing between the label bottom and the top of the input
    const spacingLabelInput = remToPixels(0.25);

    inputs.forEach((input, i) => {
        input.style.marginTop = `${inputLabelHeights[i] + spacingLabelInput}px`;
    });
};
